module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-dec-2-8ef767957a28267a4ae5177697724e8a.png";